import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useNotification } from '../../providers/notificationsProvider';
import { API_URL, getCachedSessionId } from '../../services/common';

const updateResource = async ({ resource, projectId, resourceId }) => {
  const response = await axios.put(
    `${API_URL}/v1/project/${projectId}/provider/hosting/resource/${resourceId}`,
    resource,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};

export const useUpdateResource = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotification();

  return useMutation(updateResource, {
    onError: (error) => {
      notify({ message: error.message, severity: 'error' });
    },
    onSuccess: (data) => {
      notify({ message: 'Resource was updated successfully', severity: 'success' });
      queryClient.invalidateQueries(['resource', data.resource._id]);
    }
  });
};
